import React from 'react';
import { Link } from 'react-router-dom';
import RollingArrangement from '../components/RollingArrangement/RollingArrangement';
import rollingArrangementPage from '../decorators/rollingArrangementPage';

export const ViewRollingArrangement = ({ rollingArrangement }) => {
  if (!rollingArrangement) {
    return null;
  }

  return (
    <div>
      <h1>Rolling Payment Arrangement</h1>
      <p className="links">
        <Link className="mb-4" to="/rolling-arrangements">
          &larr; Back to Rolling Arrangements
        </Link>
      </p>
      <RollingArrangement rollingArrangement={rollingArrangement} />
      <Link to={`/rolling-arrangements/${rollingArrangement.id}/edit`}>
        <button className="btn btn-default">Edit Rolling Arrangement</button>
      </Link>
    </div>
  );
};

export default rollingArrangementPage(ViewRollingArrangement);
